import React from 'react';
import styled from 'styled-components';
import {
  DropdownContainer,
  DropdownIcon,
  Option,
  OptionsContainer,
  OptionText,
} from '../../common/dropdown/styles';
import dt from '../../../../shared/theme';

const buildOption = ({
  name,
  order,
  slug,
  sortOrder,
  onClick,
}) => (
  <Option key={slug} className={slug === sortOrder ? 'selected' : ''} onClick={() => onClick(slug)}>
    <OptionText>
      {name}
      {order && <span>{order}</span>}
    </OptionText>
  </Option>
);

const SDropdownContainer = styled(DropdownContainer)`
  ${props => dt(props).theme.isMobileOrTablet && `
    width: 40px;
    padding: 0;
    justify-content: center;
  `};
`;

const SDropdownIcon = styled(DropdownIcon)`
  ${props => !dt(props).theme.isMobileOrTablet && `
    margin-right: 12px;
  `};
`;

const SOptionsContainer = styled(OptionsContainer)`
  z-index: 1300;

  ${props => !dt(props).theme.isMobileOrTablet && `
    width: 345px;
    right: 28px;
  `};

  ${props => dt(props).theme.isXLarge && `
    right: calc(50% - 476px);
  `};

  ${props => dt(props).theme.isXXLarge && `
    right: calc(50% - 600px);
  `};
`;

export {
  buildOption,
  SDropdownContainer,
  SDropdownIcon,
  SOptionsContainer,
};
